import logo from './logo.svg';
import './App.css';
import { ToastContainer } from 'react-toastify';
import "antd/dist/reset.css";
import Home from './Pages/Home';
import {
  BrowserRouter as Router,
  Routes, Route, useLocation, useRoutes, useParams
} from "react-router-dom";
import Pricing from './Pages/Pricing';
import Contact from './Pages/Contact';
import HowItWorks from './Pages/HowItWorks';
import Features from './Pages/Features';
import Faq from './Pages/Faq';
import AboutUs from './Pages/AboutUs';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsConditions from './Pages/TermsConditions';
import RefundPolicy from './Pages/RefundPolicy';
import ReactGA from "react-ga4";
import { useEffect } from 'react';
import Mainadminroute from './Pages/Admin/Pages/Mainadminroute';

function App() {

  useEffect(() => {
    ReactGA.initialize("G-XXXXXXXXXX");
  }, []);
  return (
    <Router>
      <ToastContainer />
      <Routes>
        {/* <Route path='/*' element={
          <div className="mobile-container">
            <p>Hello World </p>

          </div>}
        /> */}


        <Route path='/' element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/features" element={<Features />} />
        <Route path="/faq" element={<Faq />} />

        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        {/* <Route path='/trk/success/:id' element={<Successpage />} />
        <Route path='/ms' element={<Newimgmeesho />} />
        <Route path='/meesho' element={<Meeshoprice />} /> */}

        <Route path="/amd/ms/*" element={<Mainadminroute />} />





      </Routes>

    </Router>
  );
}

export default App;
